// extracted by mini-css-extract-plugin
export default {"list":"FlightsLabelList-module__list__MltW9","listMobile":"FlightsLabelList-module__listMobile__+zmxv"};